export default __webpack_public_path__ + "static/media/C264251.7440d731.jpg";